// extracted by mini-css-extract-plugin
module.exports = {"map":"About_map__fTyCc","wrapper":"About_wrapper__2ka5V","popup":"About_popup__5lMNc"};